<template>
  <div>
    <div>
      <FilterCard :applied-filter-count="appliedFilterCount">
        <b-row>
          <b-col
            cols="6"
            md="3"
          >
            <b-form-group
              label="Bucket"
              label-for="bucket"
            >
              <v-select
                id="bucket"
                v-model="filters['bucket_id']"
                :options="bucketOptions"
                :reduce="option => option.id"
                label="name"
                placeholder="Select Bucket"
              >
                <template v-slot:option="option">
                  {{ option.name }}
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col
            cols="6"
            md="3"
          >
            <b-form-group
              label="Assigned Branch"
              label-for="assigned-branch"
            >
              <v-select
                id="assigned-branch"
                v-model="filters['id']"
                :options="branchOptions"
                :reduce="option => option.id"
                label="name"
                placeholder="Select Branch"
              >
                <template v-slot:option="option">
                  {{ option.name }}
                </template>
              </v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Apply and Clear Filters -->
        <b-row class="mt-1">
          <b-col>
            <filter-buttons
              :filter-data="filters"
              :apply-filters="applyFilters"
              :clear-filters="clearFilters"
            />
          </b-col>
        </b-row>
      </FilterCard>
    </div>
    <div>
      <b-card
        no-body
      >
        <div>
          <b-overlay
            id="overlay-background"
            blur="10px"
            opacity="0.30"
            rounded="sm"
            variant="light"
          >
            <div
              class="m-2"
            >
              <!-- input -->
              <b-row>
                <b-col
                  md="7"
                  class="d-flex align-items-center justify-content-start mb-1 mt-1 mb-md-0"
                >
                  <b-button
                    v-can="'sorting-bucket-create'"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    class="custom-button-color"
                    @click="onClickCreateSortingBucket"
                  >
                    <feather-icon icon="PlusIcon" />
                    Add New
                  </b-button>
                </b-col>
                <b-col
                  class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
                >
                  <ReportTableButtons
                    class="mt-2"
                    :items="rows"
                    :json_fieldz="json_fields"
                    :name="`BucketManagement - Page ${page}.xls`"
                    :bulkname="`BucketManagement.xls`"
                    :fetch="fetchSortingBucketsNoPagination"
                    @refresh="onClickRefresh"
                  />
                </b-col>
              </b-row>
            </div>
            <!-- table -->
            <b-table
              :per-page="perPage"
              :items="rows"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              :sort-compare="sortCompare"
              hover
              responsive
              striped
              show-empty
              @sort-changed="sortChanged"
            >
              <template #empty>
                <TableDataFetching
                  :rows="rows"
                  :data-loading="dataLoading"
                />
              </template>
              <template #head()="{ field }">
                <div
                  class="sortable-header"
                >
                  <span class="header-text">{{ field.label }}</span>
                  <feather-icon
                    v-if="field.sortable"
                    :icon="sort === field.key
                      ? 'ArrowUpIcon'
                      : 'ArrowDownIcon'"
                    size="14"
                  />
                </div>
              </template>
              <template #cell(parent_bucket)="data">
                <div
                  class="font-weight-bold"
                >
                  {{ data.item.key ? data.item.key.split('_')[1] : 'N/A' }}
                </div>
              </template>
              <template #cell(user)="data">
                <div
                  v-if="data.value"
                  class="d-flex align-items-center"
                >
                  <div>
                    <div class="font-weight-bold">
                      {{ data.value.first_name }} {{ data.value.last_name }}
                    </div>
                    <small>{{ data.value.roles[0].name }}</small>
                  </div>
                </div>
                <div
                  v-else
                  class="font-weight-bold"
                >
                  {{ '---' }}
                </div>
              </template>
              <template #cell(updated_at)="data">
                <div
                  class="font-weight-bold"
                >
                  {{ data.value ? __dateTimeFormatter(data.value) : '---' }}
                </div>
              </template>
              <template #cell(action)="data">
                {{ data.value }}
                <b-dropdown
                  no-caret
                  toggle-class="text-decoration-none"
                  variant="link"
                >
                  <template v-slot:button-content>
                    <feather-icon
                      class="text-body align-middle mr-25"
                      icon="MoreVerticalIcon"
                      size="12"
                    />
                  </template>
                  <b-dropdown-item
                    v-can="'sorting-bucket-edit'"
                    @click="onClickEditBucket(data.item.id)"
                  >
                    <feather-icon icon="ToolIcon" />
                    Manage Bucket
                  </b-dropdown-item>
                </b-dropdown>
              </template>

            </b-table>
            <div class="mx-2 mb-2">
              <b-row>

                <b-col
                  class="d-flex align-items-center justify-content-sm-start"
                  cols="12"
                  md="3"
                >
                  <label class="width-75">Per page</label>
                  <v-select
                    v-model="perPage"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="pageOptions"
                    :clearable="false"
                    class="per-page-selector d-inline-block ml-1 width-100 mr-2"
                  />
                </b-col>
                <!-- Pagination -->
                <b-col
                  class="d-flex align-items-center justify-content-sm-end"
                  cols="12"
                  md="9"
                >
                  <span class="text-muted mr-1">Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} entries</span>
                  <b-pagination
                    v-model="page"
                    :per-page="perPage"
                    :total-rows="(meta.total)? meta.total : 0"
                    class="mb-0 mt-1 mt-sm-0"
                    first-number
                    last-number
                    next-class="next-item"
                    prev-class="prev-item"
                  >
                    <template #prev-text>
                      <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                      />
                    </template>
                    <template #next-text>
                      <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                      />
                    </template>
                  </b-pagination>

                </b-col>

              </b-row>
            </div>
          </b-overlay>

        </div>
      </b-card>
    </div>
    <bucket-management-modal ref="set_sorting_bucket" />
  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BCol,
  BFormGroup,
  BPagination,
  BRow,
  BOverlay,
  VBModal,
  BTable,
  BDropdown,
  BDropdownItem,
  VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import Filter from '@core/mixins/filter'
import vSelect from 'vue-select'
import { avatarText } from '@core/utils/filter'
import BucketManagementModal from '@/components/Sorting/BucketManagementModal.vue'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import store from '@/store/index'
import FilterButtons from '@/components/Filter/FilterButtons.vue'
import FilterCard from '@/components/FilterCard/FilterCard.vue'
import tableMixin from '@core/mixins/tableMixin'

const sortingRepository = RepositoryFactory.get('sorting')

export default {
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  components: {
    FilterCard,
    BPagination,
    BFormGroup,
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BOverlay,
    vSelect,
    BDropdown,
    BDropdownItem,
    BucketManagementModal,
    FilterButtons,
  },
  mixins: [Filter, SuccessMessage, ErrorMessage, tableMixin],
  data() {
    return {
      avatarText,
      filters: {},
      bucketOptions: [],
      branchOptions: [],
      total: 0,
      meta: {},
      dataLoading: false,
      // Start BS Table
      sort: '',
      perPage: 20,
      pageOptions: [10, 20, 50],
      totalRows: 1,
      page: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      // End BS Table
      pageLength: 20,
      dir: false,
      fields: [
        {
          key: 'name',
          label: 'Assigned Branch',
          sortable: true,
          tdClass: 'text-left',
        },
        {
          key: 'parent_bucket',
          label: 'Bucket Name',
          sortable: true,
        },
        {
          key: 'user',
          label: 'Updated By',
          sortable: true,
        },
        {
          key: 'updated_at',
          label: 'Last Updated',
          sortable: false,
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          key: 'action',
          label: 'Action',
          sortable: false,
        },
      ],
      json_fields: {
        'Assigned Branch': {
          field: 'name',
          callback: value => `"${value}"`,
        },
        'Bucket Name': {
          field: 'key',
          callback: value => `"${value ? value.split('_')[1] : 'N/A'}"`,
        },
        'Updated By': {
          field: 'user',
          callback: value => `"${value !== null ? `${value.first_name}` : 'N/A'} ${value !== null && value.last_name !== null ? `${value.last_name}` : ''}"`,
        },
        'Last Updated': {
          field: 'updated_at',
          // eslint-disable-next-line no-underscore-dangle
          callback: value => this.__dateTimeFormatter(value),
        },
      },
      rows: [],
    }
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({
          text: f.label,
          value: f.key,
        }))
    },
  },
  watch: {
    options: {
      handler() {
        this.fetchSortingBuckets()
      },
    },
    deep: true,
    page() {
      this.fetchSortingBuckets()
    },
    perPage() {
      this.fetchSortingBuckets()
    },
  },
  mounted() {
    this.fetchSortingBuckets()
    this.getBranchList()
    this.getBucketList()
    this.updateFilterCount()
  },
  methods: {
    sortCompare(a, b, key) {
      if (key === 'parent_bucket') {
        // Extract the parent bucket string from the key
        const bucketA = a.key ? a.key.split('_')[1].toLowerCase() : ''
        const bucketB = b.key ? b.key.split('_')[1].toLowerCase() : ''
        return bucketA.localeCompare(bucketB)
      }

      // Return null to let b-table use its default sorting for other columns
      return null
    },
    async fetchSortingBuckets() {
      this.dataLoading = true
      this.rows = []
      try {
        const { data } = (await sortingRepository.getSortingBuckets(this.page, this.perPage, this.filterQuery))
        this.rows = data.data
        this.meta = data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.dataLoading = false
    },
    async fetchSortingBucketsNoPagination() {
      try {
        const { data } = (await sortingRepository.getSortingBucketsNoPagination(this.filterQuery))
        return data.data
      } catch (e) {
        this.convertAndNotifyError(e)
        return []
      }
    },
    async getBranchList() {
      try {
        this.branchOptions = (await sortingRepository.getSortingBranches()).data.data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async getBucketList() {
      try {
        this.bucketOptions = (await sortingRepository.getLastBuckets()).data.data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    onClickCreateSortingBucket() {
      this.$refs.set_sorting_bucket.openModal(null, 'add')
    },
    onClickEditBucket(id) {
      this.$refs.set_sorting_bucket.openModal(id, 'edit')
    },
    changePage(value) {
      this.perPage = value
    },
    handleChangePage(page) {
      this.page = page
      this.fetchSortingBuckets()
    },
    applyFilters() {
      this.fetchSortingBuckets()
      this.updateFilterCount()
    },
    clearFilters() {
      this.filters = {}
      this.$nextTick(() => {
        this.fetchSortingBuckets()
      })
      this.updateFilterCount()
    },
    onClickRefresh() {
      this.fetchSortingBuckets()
    },
  },
}
</script>
<style lang="scss">
@import '../../@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/required.scss';
</style>
